module.exports = __webpack_public_path__ + "img/osakatit.04b53230.png";